import React, { Component } from "react";
import ContinuousColorSpec from './ContinuousColorSpec';
import DecayModeColorSpec from './DecayModeColorSpec';
import ParityColorSpec from './ParityColorSpec';
import './accordion.css';

const buttonStyle = { width: '90%', color: 'white', backgroundColor: '#707070', marginTop: '4px', boxShadow: '#959595 -1px -1px 5px' };

 export default class ColorSection extends Component {
    constructor(props) {
        super(props);
        this.state = { expanded: ['cont'] };
    }

    toggle(id) {
        this.setState(prev => ({
            expanded: prev.expanded.includes(id)
                ? prev.expanded.filter(e => e !== id)
                : [...prev.expanded, id]
        }));
    }

    renderItem(id, label, children) {
        const isExpanded = this.state.expanded.includes(id);
        return (
            <div className="accordion__item">
                <div className="accordion__heading" role="heading" aria-level={3}>
                    <button
                        type="button"
                        className="accordion__button"
                        style={buttonStyle}
                        aria-expanded={isExpanded}
                        aria-controls={`accordion__panel-${id}`}
                        id={`accordion__button-${id}`}
                        onClick={() => this.toggle(id)}
                    >
                        {label}
                    </button>
                </div>
                <div
                    className="accordion__panel"
                    role="region"
                    id={`accordion__panel-${id}`}
                    aria-labelledby={`accordion__button-${id}`}
                    hidden={!isExpanded}
                >
                    {children}
                </div>
            </div>
        );
    }

    render() {
        return (
                <div className="accordion">
                    {this.renderItem('cont', 'Continuous Attributes', <ContinuousColorSpec orientation={this.props.orientation}/>)}
                    {this.renderItem('decay', 'Discrete: Decay', <DecayModeColorSpec orientation={this.props.orientation}/>)}
                    {this.renderItem('parity', 'Discrete: Parity', <ParityColorSpec orientation={this.props.orientation}/>)}
                </div>
        )
    }
}
